import React, { useRef } from "react";
import "./Join.css";
import emailjs from "@emailjs/browser";

const Join = () => {
  const form = useRef(); // Invoke useRef to create a ref object
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_5zbsrb2", "template_jaduwma", form.current, {
        publicKey: "3B-lD7AGNVeh7QJme",
      })
      .then(
        () => {
          console.log("SUCCESS!");
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };
  return (
    <div className="join" id="join-us">
      <div className="left-j">
        <hr />
        <div>
          <span className="stroke-text">READY TO</span>
          <span>LEVEL UP</span>
        </div>
        <div>
          <span>YOUR BODY</span>
          <span className="stroke-text">WITH US</span>
        </div>
      </div>
      <div className="right-j">
        <form className="email-container" onSubmit={sendEmail} ref={form}>
          <input
            type="email"
            name="user-email"
            placeholder="Enter your email"
          />
          <button className="btn btn-join">Join Now</button>
        </form>
      </div>
    </div>
  );
};

export default Join;
